import { render, staticRenderFns } from "./PrintRadio.vue?vue&type=template&id=589ee270&scoped=true"
import script from "./PrintRadio.vue?vue&type=script&lang=js"
export * from "./PrintRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ee270",
  null
  
)

export default component.exports